import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import projectService from "./projectService";

// Get all projects
export const getProjects = createAsyncThunk(
  "project/get-projects",
  async (_, thunkAPI) => {
    try {
      return await projectService.getProjects();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Create project
export const createProject = createAsyncThunk(
  "project/create-project",
  async (projectData, thunkAPI) => {
    try {
      return await projectService.createProject(projectData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Get single project
export const getAProject = createAsyncThunk(
  "project/get-project",
  async (slug, thunkAPI) => {
    try {
      return await projectService.getProject(slug);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Update project
export const updateAProject = createAsyncThunk(
  "project/update-project",
  async (projectData, thunkAPI) => {
    try {
      return await projectService.updateProject(projectData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete project
export const deleteAProject = createAsyncThunk(
  "project/delete-project",
  async (slug, thunkAPI) => {
    try {
      return await projectService.deleteProject(slug);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Reset state
export const resetState = createAction("Reset_all");

const initialState = {
  projects: [],
  projectData: null,
  createdProject: null,
  updatedProject: null,
  deletedProject: null,

  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const projectSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // ===== GET PROJECTS =====
      .addCase(getProjects.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getProjects.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.projects = action.payload;
      })
      .addCase(getProjects.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload || action.error;
      })

      // ===== CREATE PROJECT =====
      .addCase(createProject.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createProject.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdProject = action.payload;
      })
      .addCase(createProject.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload || action.error;
      })

      // ===== GET SINGLE PROJECT =====
      .addCase(getAProject.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAProject.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.projectData = action.payload;
      })
      .addCase(getAProject.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload || action.error;
      })

      // ===== UPDATE PROJECT =====
      .addCase(updateAProject.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAProject.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedProject = action.payload;
      })
      .addCase(updateAProject.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload || action.error;
      })

      // ===== DELETE PROJECT =====
      .addCase(deleteAProject.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAProject.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedProject = action.payload;
      })
      .addCase(deleteAProject.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload || action.error;
      })

      // ===== RESET =====
      .addCase(resetState, () => initialState);
  },
});

export default projectSlice.reducer;
